import { buildContext } from "./context/contextBuilder";
//import { calculateRisk } from "./context/riskEngine";
import { predictEscalation } from "./context/predictiveEngine";
import { calculateDecision } from "./context/decisionEngine";
import { explainDecision } from "./context/explainEngine";
import { superviseIntervention } from "./context/supervisorEngine";
import { runAutonomousLoop } from "./context/autonomousEngine";
import { computeSwarmSignal } from "./context/swarmEngine";
import { runDigitalTwin } from "./context/digitalTwinEngine";
import { runCommandLayer } from "./context/commandEngine";
// eslint-disable-next-line no-unused-vars
import { computeTrust } from "./context/trustEngine";
// eslint-disable-next-line no-unused-vars
import { computeFederatedInsight } from "./context/federationEngine";
// eslint-disable-next-line no-unused-vars
import evaluatePolicy from "./context/policyEngine";
import { computeAdaptiveSignal } from "./context/adaptiveEngine";
// eslint-disable-next-line no-unused-vars
import { orchestrateIntervention } from "./context/interventionEngine";
// eslint-disable-next-line no-unused-vars
import { computeSafetyGraph } from "./context/graphEngine";
import { computeMultiZone } from "./context/multiZoneEngine";
import API from "./config/api";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";



import {
  // eslint-disable-next-line no-unused-vars
  storeIncidentMemory,
  querySimilarIncidents,
} from "./context/memoryEngine";



import { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import {
  FaExclamationTriangle,
  FaShieldAlt,
  FaBiohazard,
  FaMapMarkerAlt,
  FaBell,
  FaVolumeMute,
  FaVolumeUp,
  FaClock,
  FaSkullCrossbones,
} from "react-icons/fa";
// eslint-disable-next-line no-unused-vars
import PilotAlertsPanel from "./components/PilotAlertsPanel";
import { generateDemoRisk } from "./context/demoRiskEngine";
import { calculatePM25AQI } from "./context/aqiCalculator";
import { useTranslation } from "react-i18next";
import LanguageToggle from "./components/shared/LanguageToggle";
import DemoDataNotice from "./components/shared/DemoDataNotice";

// Staging-only KPIs (CO2, CO, AQI) — off in the public/production build.
// See Task 14: confirm with product before flipping REACT_APP_ENABLE_EXTENDED_KPIS
// to true in .env.production.
const ENABLE_EXTENDED_KPIS = process.env.REACT_APP_ENABLE_EXTENDED_KPIS === "true";



const RISK_THRESHOLD = 6.5;
const MAP_CENTER = [12.9721, 77.5933];

// eslint-disable-next-line no-unused-vars
const zoneCoordinates = {
  "Zone A": [13.0827, 80.2707],
  "Zone B": [13.0870, 80.2800],
  "Zone C": [13.0780, 80.2600],
};

export default function FentaSafeDashboard({ mode = "demo" }) {
  const { t } = useTranslation();

  const organization =
  localStorage.getItem("FENTASAFE_ORG") || "Unknown Organization";

  const roleName =
  localStorage.getItem("FENTASAFE_ROLE") || "Unknown Role";
  const handleLogout = () => {
  localStorage.removeItem("FENTASAFE_TOKEN");
  localStorage.removeItem("FENTASAFE_ROLE");
  localStorage.removeItem("FENTASAFE_ORG");

  window.location.href = "/live";
};
  
  const [twinState, setTwinState] = useState(null);
  const [commandState, setCommandState] = useState(null);
  const isDemo = mode === "demo";
  const [fentanyl, setFentanyl] = useState(0);
  const [voc, setVoc] = useState(0);
  const [pm25, setPm25] = useState(0);
  const [temperature, setTemperature] = useState(0);
  const [humidity, setHumidity] = useState(0);
  // Staging-only (see ENABLE_EXTENDED_KPIS) — CO2/CO simulated readings, AQI
  // computed from the real PM2.5 breakpoint formula, not Math.random().
  const [co2, setCo2] = useState(0);
  const [co, setCo] = useState(0);
  const [aqi, setAqi] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [eventLog, setEventLog] = useState([]);
  const [fentanylTrend, setFentanylTrend] = useState([]);
  const [risk, setRisk] = useState({ score: 0, level: "SAFE" });
  const [zoneState, setZoneState] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [f, setFentanylValue] = useState(0);
  const fetchRisk = async (context) => {

  try {

    const token = localStorage.getItem("FENTASAFE_TOKEN");

    const res = await fetch(`${API}/api/sensor`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        device_id: "frontend",
        pm25: context.pm25,
        temperature: context.temperature,
        humidity: context.humidity,
        voc: context.voc,
        fentanyl_ppb: context.fentanyl
      })
    });

    const data = await res.json();
    return data.risk;

  } catch (error) {

    console.log("Demo Mode - Backend unavailable");

    return null;
  }
};

  useEffect(() => {
  const loadRisk = async () => {

    if (isDemo) {
      return;
    }

    const context = {
      fentanyl,
      voc,
      pm25,
      temperature: 30,
      humidity: 50,
    };

    const result = await fetchRisk(context);

    if (result) {
      setRisk(result);
    }
  };

  loadRisk();

}, [fentanyl, voc, pm25, isDemo]);

  const [role, setRole] = useState("OPERATOR"); // or "VIEWER"
  const canAcknowledge = role === "OPERATOR";
  const [soundEnabled, setSoundEnabled] = useState(true);
  const soundEnabledRef = useRef(true);
  const sirenRef = useRef(null);
  const alertActive = useRef(false);
  // eslint-disable-next-line no-unused-vars
  const riskLevel = risk.level;
  const [lastUpdate, setLastUpdate] = useState(null);
  const systemOnline =
  lastUpdate && Date.now() - lastUpdate.getTime() < 10000;
  const [alertCount, setAlertCount] = useState(0);
  const [uptimeSeconds, setUptimeSeconds] = useState(0);
  const [showBannerAlert, setShowBannerAlert] = useState(false);
  const [operatorActions, setOperatorActions] = useState([]);
  // OPERATOR ACTION POPUP
  const [showActionPopup, setShowActionPopup] = useState(false);
  const [actionText, setActionText] = useState("");
  const [pendingAlertType, setPendingAlertType] = useState(null); // "RISK"
  const [feedbackLog, setFeedbackLog] = useState([]);
  const [decision, setDecision] = useState(null);
  const [explanation, setExplanation] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [interventionPlan, setInterventionPlan] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [adaptiveSignal, setAdaptiveSignal] = useState(null);
  const [supervisorState, setSupervisorState] = useState(null);
  const [lastActionTime, setLastActionTime] = useState(null);
  const [autoState, setAutoState] = useState(null);
  const [swarmState, setSwarmState] = useState(null);
  const [similarIncidents, setSimilarIncidents] = useState([]);
  const [trustState, setTrustState] = useState(null);
  const [federationState, setFederationState] = useState(null);
  const [policyState, setPolicyState] = useState(null);
  const [graphState, setGraphState] = useState(null);    
  // eslint-disable-next-line no-unused-vars
  const riskAlertActive = useRef(false);

 useEffect(() => {
  if (!soundEnabled) {
    stopSiren();
    setShowAlert(false);
  }
}, [soundEnabled]);


useEffect(() => {
  soundEnabledRef.current = soundEnabled;
}, [soundEnabled]);

/* ---------- RESET WHEN SWITCHING TO LIVE ---------- */
useEffect(() => {
  if (isDemo) return;

  // 🔕 stop everything immediately
  stopSiren();

  // reset alert refs
  alertActive.current = false;

  // reset alert UI
  setShowAlert(false);
  setShowBannerAlert(false);

}, [isDemo]);

  /* ---------- AUDIO SETUP ---------- */
  useEffect(() => {
    const audio = new Audio("/alert.mp3");
    audio.loop = true;
    sirenRef.current = audio;

    const unlock = () => {
      audio
        .play()
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
        })
        .catch(() => {});
      document.removeEventListener("click", unlock);
    };

    document.addEventListener("click", unlock);
  }, []);

  const startSiren = () => {
  // Allow siren in both demo and live mode
  // In live mode, integrates with real incident alerting
  // User can mute via the Alerts MUTED button
  if (!sirenRef.current || !soundEnabledRef.current) return;
  sirenRef.current.currentTime = 0;
  sirenRef.current.play().catch(() => {});
};


  const stopSiren = () => {
    if (!sirenRef.current) return;
    sirenRef.current.pause();
    sirenRef.current.currentTime = 0;
  };

useEffect(() => {
  const pulseStyle = document.createElement("style");

  pulseStyle.innerHTML = `
  @keyframes pulseRisk {
    0% { opacity: 1; }
    50% { opacity: 0.6; }
    100% { opacity: 1; }
  }
  `;

  document.head.appendChild(pulseStyle);

  return () => {
    document.head.removeChild(pulseStyle);
  };
}, []);


  /* ---------- LIVE MODE RESET ---------- */
useEffect(() => {
  if (isDemo) return;

  stopSiren();
  setShowAlert(false);
  setShowBannerAlert(false);

  setFentanyl(0);
  setVoc(0);
  setPm25(0);
  setTemperature(0);
  setHumidity(0);
  setCo2(0);
  setCo(0);
  setAqi(0);

  setAlertCount(0);
  setEventLog([]);
  setFentanylTrend([]);
}, [isDemo]);

/* ---------- EVENT LOG ---------- */
// Stores the translation key + raw params rather than a rendered string, so
// entries re-render in whatever language is active now (not the language
// that was active when the entry was logged) — important for a live demo
// where the operator may switch languages mid-session.
const addLog = (key, params = {}) => {
  const time = new Date().toLocaleTimeString();
  setEventLog((prev) => [{ time, key, params }, ...prev].slice(0, 20));
};

const renderLogEntry = (entry) => {
  const params =
    entry.key === "demo.eventLog.actionRecordedBy"
      ? {
          ...entry.params,
          type: t(`demo.alertTypeValue.${entry.params.type}`, entry.params.type),
          role: t(`demo.roleLabel.${entry.params.role}`, entry.params.role),
        }
      : entry.params;
  return `${entry.time}   ${t(entry.key, params)}`;
};

/* ---------- EXPORT OPERATOR ACTIONS ---------- */
const exportActionsToCSV = () => {
  if (operatorActions.length === 0) {
    alert(t("demo.controlBar.noActionsToExport"));
    return;
  }

  const headers = ["Time", "Alert Type", "Action Taken", "Operator"];
  const rows = operatorActions.map(a => [
    a.time,
    a.type,
    a.action.replace(/,/g, " "),
    a.operator,
  ]);

  const csvContent =
    [headers, ...rows].map(row => row.join(",")).join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `FentaSafe_Operator_Actions_${new Date().toISOString()}.csv`;
  link.click();

  URL.revokeObjectURL(url);
};
  /* ---------- DEMO DATA ---------- */
  useEffect(() => {
  if (!isDemo) return; // 🚫 LIVE MODE DOES NOTHING
    const iv = setInterval(() => {
      const f = +(Math.random() * 9).toFixed(1);
      setFentanylValue(f);

/* ⭐ NEW — capture values first */
const vocValue = Math.floor(Math.random() * 300);
const pmValue = Math.floor(Math.random() * 150);
const temperatureValue = +(18 + Math.random() * 8).toFixed(1); // ~18-26°C indoor range
const humidityValue = Math.floor(30 + Math.random() * 30); // ~30-60% indoor range
setTemperature(temperatureValue);
setHumidity(humidityValue);

if (ENABLE_EXTENDED_KPIS) {
  const co2Value = Math.floor(400 + Math.random() * 1200); // ~400-1600 ppm indoor range
  const coValue = +(Math.random() * 9).toFixed(1); // ~0-9 ppm
  setCo2(co2Value);
  setCo(coValue);
  setAqi(calculatePM25AQI(pmValue)); // real EPA PM2.5 breakpoint formula, simulated input
}

/* CONTEXT */
const context = buildContext({
  fentanyl: f,
  voc: vocValue,
  pm25: pmValue,
  zone: "Campus Zone A",

});

const zones = computeMultiZone({
  fentanyl: f,
  voc: vocValue,
  pm25: pmValue,
});
setZoneState(zones);


const neighborSignals = [
  { fentanyl: Math.random() * 9 },
  { fentanyl: Math.random() * 9 },
];



const swarm = computeSwarmSignal(context, neighborSignals);
setSwarmState(swarm);

// ===== INTELLIGENCE PIPELINE =====

// Trend
const nextTrend = [...fentanylTrend, f].slice(-12);
setFentanylTrend(nextTrend);

// Prediction
const prediction = predictEscalation(nextTrend);

// Adaptive
const adaptive = computeAdaptiveSignal(feedbackLog);

// Memory
const memoryMatches = querySimilarIncidents(context);
setSimilarIncidents(memoryMatches);

// Decision
const decisionResult = calculateDecision(
  context,
  risk,
  prediction,
  adaptive,
  swarm,
  memoryMatches
);

// ================= DIGITAL TWIN =================
const twin = runDigitalTwin({
  context,
  risk,
  prediction,
  adaptive,
  swarm,
});

setTwinState(twin);

// ================= COMMAND LAYER =================
const command = runCommandLayer({
  twin,
  decision: decisionResult,
  mode: "SUPERVISED",
});

setCommandState(command);


// eslint-disable-next-line no-lone-blocks
{/* ================= Explanation ================= */}
const explanationResult = explainDecision({
  context,
  risk,
  prediction,
  decision: decisionResult,
  adaptive,
});

// eslint-disable-next-line no-lone-blocks
{/* ================= SUPERVISOR ================= */}
const supervisor = superviseIntervention({
  decision: decisionResult,
  prediction,
  adaptive,
  lastActionTime,
});
setSupervisorState(supervisor);

// ================= AUTONOMOUS LOOP =================
const autoResult = runAutonomousLoop({
  supervisorState: supervisor,
  lastActionTime,
  risk,           // ✅ ADD THIS
});

if (autoResult) {
  setAutoState(autoResult);
  setLastActionTime(Date.now());

  addLog("demo.eventLog.autonomousAction", { action: autoResult.action });
}

// 🔥 FORCE trigger if critical
const now = Date.now();

if (
  !autoResult &&
  risk.level === "CRITICAL" &&
  (!lastActionTime || now - lastActionTime > 10000)
) {
  setAutoState({
    stage: "supervisedReview",
    action: "humanAssessmentRecommended",
    confidence: 95,
  });

  setLastActionTime(now);

  addLog("demo.eventLog.supervisorReviewInitiated");
}
// Final state updates
setDecision(decisionResult);
setExplanation(explanationResult);

// ================= POLICY / TRUST / NETWORK / GRAPH =================
setPolicyState({
  authority: "schoolAdmin",
  privacyLevel: "high",
  message: "actionWithinScope",
});

setTrustState({
  trustScore: 87,
  mode: "aiAssisted",
  message: "highConfidenceCorrelation",
});

setFederationState({
  signal: "localized",
  message: "noCrossZonePropagation",
});

setGraphState({
  clusterRisk: "ISOLATED",
  forecast: "STABLE",
  message: "incidentContained",
});

// 🚨 RISK ALERT
if (risk.level === "CRITICAL" && !alertActive.current) {
  alertActive.current = true;

  if (!soundEnabledRef.current) {
    setShowBannerAlert(true);
    setAlertCount(prev => prev + 1);
    return;
  }

  setShowAlert(true);
  startSiren();
  addLog("demo.eventLog.criticalRiskDetected");
  setAlertCount(prev => prev + 1);
}

// RESET
if (risk.level !== "CRITICAL" && alertActive.current) {
  alertActive.current = false;
  setShowAlert(false);
  setShowBannerAlert(false);
  stopSiren();
  addLog("demo.eventLog.riskReturnedSafe");
}


const demoRisk = generateDemoRisk();
setRisk(demoRisk);
setFentanyl(f);
setVoc(vocValue);
setPm25(pmValue);
setLastUpdate(new Date());

setUptimeSeconds(prev => prev + 3);

}, 3000);

return () => clearInterval(iv);
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDemo, soundEnabled, fentanylTrend, feedbackLog]);

/* ---------- RENDER ---------- */
console.log("showAlert value:", showAlert);

return (
  <div
    style={{
      ...styles.page,   // ✅ ROOT CONTAINER MUST USE styles.page
      pointerEvents: "auto",
    }}
  >


{/* COMMAND HEADER */}
<div
  style={{
    ...styles.header,
    borderBottom: isDemo
      ? "1px solid #1e293b"
      : "3px solid #16a34a",
    background: "rgba(2,6,23,0.85)",
    backdropFilter: "blur(6px)",
  }}
>
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <h1 style={styles.title}>FentaSafe</h1>

  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
    <LanguageToggle />

    {!isDemo && (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        color: "#22c55e",
        fontWeight: "600",
        fontSize: "0.85rem",
      }}
    >
      <span>{organization}</span>

      <span style={{ opacity: 0.7 }}>
        |
      </span>

      <span>{roleName}</span>

      <span style={{ opacity: 0.7 }}>
        |
      </span>

      <button
        onClick={handleLogout}
        style={{
          background: "#dc2626",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "4px 10px",
          cursor: "pointer",
          fontSize: "0.8rem",
        }}
      >
        {t("demo.logout")}
      </button>
    </div>
    )}
  </div>
 </div>





  <div style={styles.subtitleWrap}>
    <div style={styles.subtitleMain}>
      {t("demo.subtitle")}
    </div>

    <div
      style={{
        ...styles.subtitleDemo,
        color: isDemo ? "#fbbf24" : "#22c55e",
      }}
    >
      {t("demo.mode")}: {isDemo ? t("demo.modeDemo") : t("demo.modeLive")} &nbsp;|&nbsp;
      {t("demo.facility")}: {isDemo ? t("demo.facilityDemo") : t("demo.facilityLive")}
    </div>

    <div style={{ fontSize: "0.85rem", opacity: 0.7, marginTop: 6 }}>
      {t("demo.tagline")}
    </div>
  </div>
</div>


   <div style={{ pointerEvents: "auto", position: "relative", zIndex: 50 }}>
    </div>
  {showBannerAlert && (
  <div style={styles.bannerAlert}>
    <FaExclamationTriangle /> {t("demo.bannerAlert")}
  </div>
)}





{/* TOP CONTROL BAR */}
<div style={{ ...styles.controlBar, pointerEvents: "auto" }}>

  {/* ROLE TOGGLE */}
  <button
    onClick={() => {
      if (isDemo) {
        setRole(role === "OPERATOR" ? "VIEWER" : "OPERATOR");
      } else {
        alert(t("demo.controlBar.operatorRoleRequiresAuth"));
      }
    }}
    style={{
      ...styles.audioBtn,
      background: role === "OPERATOR" ? "#16a34a" : "#475569",
    }}
  >
    {t("demo.controlBar.role", { role: t(`demo.roleLabel.${role}`, role) })}

<div
  style={{
    background: "#065f46",
    color: "#fff",
    padding: "8px 14px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "0.85rem",
  }}
>
  {t("demo.controlBar.humanInTheLoopLabel")} {t("commandCenter.status.active")}
</div>

  </button>

  {/* SOUND TOGGLE */}
   <button
  onClick={exportActionsToCSV}
  style={{
    ...styles.audioBtn,
    background: "#0ea5e9",
  }}
>
  {t("demo.controlBar.exportCsv")}
</button>


  <button
    onClick={() => {
      setSoundEnabled(prev => {
        soundEnabledRef.current = !prev;
        if (prev) {
          stopSiren();
          setShowAlert(false);
        }
        return !prev;
      });
    }}
    style={{
      ...styles.audioBtn,
      background: soundEnabled ? "#dc2626" : "#2563eb",
    }}
  >
    {soundEnabled ? (
      <>
        <FaVolumeUp /> {t("demo.controlBar.alertsOn")}
      </>
    ) : (
      <>
        <FaVolumeMute /> {t("demo.controlBar.alertsMuted")}
      </>
    )}
  </button>

</div>

    {/* DEMO DISCLAIMER */}
{isDemo && (
  <div style={styles.demoNotice}>
  <strong>{t("demo.disclaimers.demoModeTitle")}</strong><br />
  {t("demo.disclaimers.demoModeText")}
</div>
)}

<div style={styles.demoNotice}>
  <strong>{t("demo.disclaimers.execSummaryTitle")}</strong><br />
  {t("demo.disclaimers.execSummaryText")}
</div>


      {/* GLOBAL RISK STATUS */}
<div style={styles.riskBanner(risk.level)}>
  <span style={{ fontSize: "1.2rem", fontWeight: 600 }}>
    {t("demo.riskBanner.overallStatus")}
  </span>

  <span style={{
    fontSize: "1.4rem",
    fontWeight: 700,
    color:
      risk.level === "CRITICAL" ? "#ef4444" :
      risk.level === "WARNING" ? "#f59e0b" :
      risk.level === "ELEVATED" ? "#3b82f6" :
      "#22c55e"
  }}>
    {t(`commandCenter.risk.${risk.level}`, risk.level)}
  </span>
</div>

<div style={styles.riskMeterContainer}>
  <div
    style={{
      ...styles.riskMeter,
      width:
        risk.level === "SAFE"
          ? "35%"
          : risk.level === "WARNING"
          ? "65%"
          : "100%",
      background:
        risk.level === "SAFE"
          ? "#22c55e"
          : risk.level === "WARNING"
          ? "#f59e0b"
          : "#ef4444",
      animation:
  risk.level === "CRITICAL"
    ? "pulseRisk 1s infinite"
    : "none",
    }}
  />
</div>
<div style={styles.aiGrid}>

  {/* ROW 1 */}
  <div style={{ ...styles.card, ...getRiskStyle(risk.level) }}>
  <h2>{t("demo.cards.recommendedActions")}</h2>
    <div>{decision?.action ? t(`demo.engine.decisionActions.${decision.action}`) : t("demo.cards.noAction")}</div>
  </div>

  <div style={styles.card}>
    <h2>{t("demo.cards.interventionTimeline")}</h2>
    {supervisorState ? (
      <>
        <strong>{supervisorState.stage === "monitoring" ? t("commandCenter.status.monitoring") : t(`demo.engine.supervisorStage.${supervisorState.stage}`)}</strong>
        <div>{t(`demo.engine.supervisorMessage.${supervisorState.message}`)}</div>
      </>
    ) : t("demo.cards.noData")}
  </div>

  <div style={styles.card}>
    <h2>{t("demo.cards.commandLayer")}</h2>
    {commandState ? (
      <>
        <strong>{t("demo.cards.authority", { value: t(`demo.engine.commandAuthority.${commandState.authority}`) })}</strong>
        <div>{t(`demo.engine.commandMessage.${commandState.message}`)}</div>
      </>
    ) : t("demo.cards.noCommand")}
  </div>

  {/* ROW 2 */}
  <div style={styles.card}>
    <h2>{t("demo.cards.policyCompliance")}</h2>
    {policyState ? (
      <>
        <div>{t("demo.cards.authority", { value: t(`demo.engine.policyAuthority.${policyState.authority}`) })}</div>
        <div>{t("demo.cards.privacy", { value: t(`demo.engine.policyPrivacy.${policyState.privacyLevel}`) })}</div>
        <div>{t(`demo.engine.policyMessage.${policyState.message}`)}</div>
      </>
    ) : t("demo.cards.noPolicy")}
  </div>

  <div style={styles.card}>
    <h2>{t("demo.cards.regionalSwarmSignal")}</h2>
    {swarmState ? (
      <>
        <strong>{swarmState.swarmRisk === "ELEVATED" ? t("commandCenter.risk.ELEVATED") : t("demo.engine.swarmRisk.normal")}</strong>
        <div>{swarmState.message && t(`demo.engine.swarmMessage.${swarmState.message}`)}</div>
      </>
    ) : t("demo.cards.noSignal")}
    <DemoDataNotice textKey="common.demoDataNotice.realCalcSimulatedInputs" />
  </div>

<div style={{ ...styles.card, ...getRiskStyle(risk.level) }}>
<h2>{t("demo.cards.digitalTwinForecast")}</h2>
    {twinState ? (
      <>
        <div>{t("demo.cards.currentRisk", { value: t(`commandCenter.risk.${twinState.currentRisk}`, twinState.currentRisk) })}</div>
        <div>{t("demo.cards.forecastTrendIncreasing")}</div>
        <div>{t("demo.cards.projectedImpactLocalized")}</div>
        <div>{t("demo.cards.supervisorReviewRecommended")}</div>
      </>
    ) : t("demo.cards.noSimulation")}
  </div>

  {/* ROW 3 */}
  <div style={styles.card}>
    <h2>{t("demo.cards.aiTrustLevel")}</h2>
    {trustState ? (
      <>
        <div>{t("demo.cards.score", { value: trustState.trustScore })}</div>
        <div>{t("demo.cards.modeValue", { value: t(`demo.engine.trustMode.${trustState.mode}`) })}</div>
        <div>{t(`demo.engine.trustMessage.${trustState.message}`)}</div>
      </>
    ) : t("demo.cards.noTrustData")}
    <DemoDataNotice textKey="common.demoDataNotice.staticNotLive" />
  </div>

  <div style={styles.card}>
    <h2>{t("demo.cards.networkIntelligence")}</h2>
    {federationState ? (
      <>
        <strong>{t(`demo.engine.federationSignal.${federationState.signal}`)}</strong>
        <div>{t(`demo.engine.federationMessage.${federationState.message}`)}</div>
      </>
    ) : t("demo.cards.noNetworkData")}
    <DemoDataNotice textKey="common.demoDataNotice.staticNotLive" />
  </div>

  <div style={styles.card}>
    <h2>{t("demo.cards.globalSafetyGraph")}</h2>
    {graphState ? (
      <>
        <div>{t("demo.cards.pattern", { value: t(`commandCenter.status.${graphState.clusterRisk.toLowerCase()}`, graphState.clusterRisk) })}</div>
        <div>{t("demo.cards.forecast", { value: t(`commandCenter.status.${graphState.forecast.toLowerCase()}`, graphState.forecast) })}</div>
        <div>{t(`demo.engine.graphMessage.${graphState.message}`)}</div>
      </>
    ) : t("demo.cards.noGraphData")}
    <DemoDataNotice textKey="common.demoDataNotice.staticNotLive" />
  </div>

{/* ================= MULTI-ZONE ================= */}
<div style={styles.card}>
  <h2>{t("demo.cards.multiZoneRiskMap")}</h2>

  {zoneState && zoneState.length > 0 ? (
    zoneState.map((z, i) => (
      <div key={i} style={{ marginBottom: "6px" }}>
        <strong>{t(`commandCenter.regionalRiskMap.${z.zone}`, z.zone)}</strong> — {t(`commandCenter.risk.${z.level}`, z.level)} ({z.riskScore})
      </div>
    ))
  ) : (
    <div style={{ opacity: 0.6 }}>{t("demo.cards.noZoneData")}</div>
  )}
 </div>


<div style={styles.card}>
  <h3>{t("demo.cards.whyRiskIncreased")}</h3>

  {explanation?.reasons && explanation.reasons.length > 0 ? (
    explanation.reasons.map((r, i) => (
      <div key={i} style={{ fontSize: "12px", marginBottom: "4px" }}>
        🔹 {t(`demo.engine.explainReasons.${r}`, r)}
      </div>
    ))
  ) : (
    <div style={{ opacity: 0.6 }}>
      {t("demo.cards.noActiveRiskFactors")}
    </div>
  )}
</div>

   <div style={styles.card}>
    <h2>{t("demo.cards.aiExplanation")}</h2>

    {!explanation && (
    <div style={{ opacity: 0.6 }}>
      {t("demo.cards.aiReasoningNotAvailable")}
    </div>
    )}

  {explanation && (
    <>
      {/* Summary */}
      <div style={{ marginBottom: 10, fontWeight: 500 }}>
        {t(`demo.engine.explainSummary.${explanation.summary}`, explanation.summary)}
      </div>

      {/* Reasons */}
      {Array.isArray(explanation.reasons) &&
        explanation.reasons.map((r, i) => (
          <div key={i} style={{ fontSize: "0.9rem", opacity: 0.85 }}>
            • {t(`demo.engine.explainReasons.${r}`, r)}
          </div>
        ))}

      {/* Confidence */}
      {explanation.confidence !== undefined && (
        <div style={{ marginTop: 10, fontSize: "0.85rem", opacity: 0.7 }}>
          {t("demo.cards.confidence", { value: explanation.confidence })}
        </div>
      )}
    </>
  )}
</div>
</div>

<div style={styles.aiGrid}>

  {/* Memory */}
  <div style={styles.card}>
    <h2>{t("demo.cards.safetyMemoryIntelligence")}</h2>

    {!similarIncidents?.length && (
      <div style={{ opacity: 0.6 }}>
        {t("demo.cards.noSimilarPastIncidents")}
      </div>
    )}

    <div style={styles.memoryGrid}>
      {similarIncidents?.map((m, i) => (
        <div key={i} style={styles.memoryItem}>
          <div style={{ fontWeight: 600 }}>{m.zone}</div>
          <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
            {t("demo.cards.riskLabel", { value: t(`commandCenter.risk.${m.risk?.level}`, m.risk?.level) })}
          </div>
        </div>
      ))}
    </div>
  </div>

  <div style={styles.card}>
  <h2>{t("demo.cards.earlySignalIndex")}</h2>
  <div style={{ fontSize: "2rem", fontWeight: 700 }}>
    {risk.early_signal_index || 0}
  </div>
  <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
    {t("demo.cards.predictiveRiskIndicator")}
  </div>
</div>

  {/* Autonomous */}
  <div style={{ ...styles.card, ...getRiskStyle(risk.level)}}>
  <h2>{t("demo.cards.recommendedResponse")}</h2>

    {autoState ? (
      <>
        <div><strong>{t(`demo.engine.autoStage.${autoState.stage}`, autoState.stage)}</strong></div>
        <div>{t(`demo.engine.autoAction.${autoState.action}`, autoState.action)}</div>
        <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
          {t("demo.cards.confidence", { value: autoState.confidence })}
        </div>
      </>
    ) : (
      <div style={{ opacity: 0.6 }}>
        {t("demo.cards.awaitingSupervisorReview")}
      </div>
    )}
  </div>

</div>


{/* SYSTEM HEALTH PANEL   STEP 2.4 */}
<div style={styles.healthPanel}>
  <span>
🟢 {t("demo.systemHealth.systemStatus")}
    <strong style={{ color: systemOnline ? "#22c55e" : "#ef4444" }}>
    {systemOnline ? t("commandCenter.status.online") : t("commandCenter.status.offline")}
    </strong>
  </span>

  <span>
    <FaClock /> {t("demo.systemHealth.lastUpdate")}{" "}
    <strong>
      {lastUpdate ? lastUpdate.toLocaleTimeString() : " "}
    </strong>
  </span>

  <span>
    <FaBell />{t("demo.systemHealth.operatingMode")} <strong>{isDemo ? t("commandCenter.status.demonstration") : t("demo.systemHealth.live")}</strong>
  </span>
</div>


{/* KPI METRICS STRIP   STEP 3 */}
<div
  style={{
    ...styles.kpiStrip,
    borderTop: isDemo ? "none" : "4px solid #16a34a",
    boxShadow: isDemo ? "none" : "0 0 12px rgba(34,197,94,0.35)",
  }}
>

  <div>
    <div style={styles.kpiValue}>{alertCount}</div>
    <div style={styles.kpiLabel}>{t("demo.kpi.activeAlerts")}</div>
  </div>

  <div>
    <div style={styles.kpiValue}>
      {fentanylTrend.length
        ? (fentanylTrend.reduce((a, b) => a + b, 0) / fentanylTrend.length).toFixed(1)
        : " "}
    </div>
    <div style={styles.kpiLabel}>{t("demo.kpi.riskIndex")}</div>
  </div>

  <div>
    <div style={styles.kpiValue}>
      {Math.floor(uptimeSeconds / 60)}m
    </div>
    <div style={styles.kpiLabel}>{t("demo.kpi.uptime")}</div>
  </div>

  <div>
    <div
      style={{
        ...styles.kpiValue,
        color:
  risk.level === "CRITICAL"
    ? "#ef4444"
    : risk.level === "ELEVATED"
    ? "#f59e0b"
    : "#22c55e",
      }}
    >
      {t(`commandCenter.risk.${risk.level}`, risk.level)}
    </div>
    <div style={styles.kpiLabel}>{t("demo.kpi.riskConfidence")}</div>
  </div>
  {/* LIVE-ONLY KPIs */}
{!isDemo && (
  <>
    <div style={{ opacity: 0.9 }}>
      <div style={{ ...styles.kpiValue, color: "#22c55e" }}>
        128
      </div>
      <div style={styles.kpiLabel}>{t("demo.kpi.sensorsOnline")}</div>
    </div>

    <div style={{ opacity: 0.9 }}>
      <div style={{ ...styles.kpiValue, color: "#22c55e" }}>
        24
      </div>
      <div style={styles.kpiLabel}>{t("demo.kpi.cctvFeeds")}</div>
    </div>

    <div style={{ opacity: 0.9 }}>
      <div style={{ ...styles.kpiValue, color: "#22c55e" }}>
        38s
      </div>
      <div style={styles.kpiLabel}>{t("demo.kpi.avgResponseTime")}</div>
    </div>
  </>
)}
</div>


{/* ================= MAIN GRID ================= */}
<div style={styles.grid}>

  {/* LEFT COLUMN   FENTANYL */}
  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

    <div style={styles.card}>
      <h2><FaBiohazard /> {t("demo.mainGrid.environmentalSafetySignals")}</h2>

      <div style={styles.kpiGrid}>
        <div style={styles.kpiBox}>
          <div style={styles.kpiTitle}>PPB</div>
          <div style={styles.kpiNumber}>{fentanyl}</div>
        </div>

        <div style={styles.kpiBox}>
          <div style={styles.kpiTitle}>VOC</div>
          <div style={styles.kpiNumber}>{voc}</div>
        </div>

        <div style={styles.kpiBox}>
          <div style={styles.kpiTitle}>PM2.5</div>
          <div style={styles.kpiNumber}>{pm25}</div>
        </div>

        <div style={styles.kpiBox}>
          <div style={styles.kpiTitle}>{t("demo.mainGrid.temperature")}</div>
          <div style={styles.kpiNumber}>{temperature}°C</div>
        </div>

        <div style={styles.kpiBox}>
          <div style={styles.kpiTitle}>{t("demo.mainGrid.humidity")}</div>
          <div style={styles.kpiNumber}>{humidity}%</div>
        </div>

        {ENABLE_EXTENDED_KPIS && (
          <>
            <div style={styles.kpiBox}>
              <div style={styles.kpiTitle}>{t("demo.mainGrid.co2")}</div>
              <div style={styles.kpiNumber}>{co2} ppm</div>
            </div>

            <div style={styles.kpiBox}>
              <div style={styles.kpiTitle}>{t("demo.mainGrid.co")}</div>
              <div style={styles.kpiNumber}>{co} ppm</div>
            </div>

            <div style={styles.kpiBox}>
              <div style={styles.kpiTitle}>{t("demo.mainGrid.aqi")}</div>
              <div style={styles.kpiNumber}>{aqi}</div>
            </div>
          </>
        )}
      </div>
    </div>

    <div style={styles.card}>
      <h2><FaBell /> {t("demo.mainGrid.riskEventLog")}</h2>

      <div style={styles.logBox}>
  {eventLog.length === 0 ? (

    <div style={{ opacity: 0.6 }}>{t("demo.mainGrid.noRiskEventsRecorded")}</div>
  ) : (
    eventLog.map((entry, i) => (
      <div key={i}>
        🔹 {renderLogEntry(entry)}
      </div>
    ))
  )}
</div>
    </div>

  </div> {/* ? LEFT COLUMN CLOSED */}

  {/* CENTER COLUMN   MAP */}
  <div style={styles.card}>
    <h2><FaMapMarkerAlt /> {t("demo.mainGrid.activeMonitoringZone")}</h2>
    <MapContainer center={MAP_CENTER} zoom={17} style={{ height: 320 }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Circle
        center={MAP_CENTER}
        radius={120}
        pathOptions={{
          color: risk.level === "CRITICAL" ? "#dc2626" : "#fbbf24",
          fillColor: risk.level === "CRITICAL" ? "#dc2626" : "#fbbf24",
          fillOpacity: 0.35,
          weight: 3,
        }}
      />
      <Marker position={MAP_CENTER}>
        <Popup>{t("demo.mainGrid.mapPopup")}</Popup>
      </Marker>
    </MapContainer>
  </div>

  {/* RIGHT COLUMN */}
  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

    <div style={{ ...styles.card, ...styles.statusCard }}>
      <h2><FaShieldAlt /> {t("demo.mainGrid.environmentalRiskStatus")}</h2>
      <p><strong>{t("demo.mainGrid.status")}</strong> {t(`commandCenter.risk.${risk.level}`, risk.level)}</p>
    </div>

    <div style={{ ...styles.card, marginTop: 46 }}>
       <h2><FaBell /> {t("demo.mainGrid.incidentEventLog")}</h2>
       <div style={styles.logBox}>
       {eventLog.slice(0, 10).map((entry, i) => (
          <div key={i}>{renderLogEntry(entry)}</div>
        ))}
      </div>
     </div>
    </div>

</div> {/* ? MAIN GRID CLOSED */}


{/* ================= TRENDS & OPERATOR ACTIONS ================= */}
<div style={styles.bottomRow}>

  {/* RISK TREND */}
  <div style={styles.card}>
    <h2>{t("demo.trends.environmentalRiskTrend")}</h2>
    <div style={styles.trendRowCompact}>
      {fentanylTrend.map((v, i) => (
        <div
          key={i}
          style={{
            ...styles.trendBar,
            height: Math.max(v * 4, 8),
            background: v >= RISK_THRESHOLD ? "#dc2626" : "#f59e0b",
          }}
        />
      ))}
    </div>
  </div>

  {/* RISK OPERATOR ACTIONS */}
  <div style={styles.card}>
    <h2>{t("demo.trends.riskOperatorActions")}</h2>
    <div style={styles.logBoxTall}>
      {operatorActions.filter(a => a.type === "RISK").length === 0 ? (
        <div style={{ opacity: 0.6 }}>{t("demo.trends.noOperatorActionsRecorded")}</div>
      ) : (
        operatorActions
          .filter(a => a.type === "RISK")
          .map((a, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <strong>{a.time}</strong>
              <div>{a.action}</div>
            </div>
          ))
      )}
    </div>
  </div>

</div>


{/* CRITICAL RISK ALERT POPUP */}
{showAlert && isDemo && (
  <div style={{ ...styles.popupBg, pointerEvents: "auto" }}>
    <div style={styles.popup}>
      <h2><FaSkullCrossbones /> {t("demo.popups.criticalRiskAlert")}</h2>
      <p>{t("demo.popups.unsafeRiskDetected")}</p>
      <button
        disabled={!canAcknowledge}
        onClick={() => {
          if (!canAcknowledge) return;

          // Close alert popup
          setShowAlert(false);
          stopSiren();

          // Open operator action popup
          setPendingAlertType("RISK");
          setShowActionPopup(true);
        }}
        style={{
          ...styles.ackBtn,
          opacity: canAcknowledge ? 1 : 0.5,
          cursor: canAcknowledge ? "pointer" : "not-allowed",
        }}
      >
        {canAcknowledge ? t("demo.popups.acknowledge") : t("demo.popups.viewOnly")}
      </button>
    </div>
  </div>
)}

<div style={{ marginTop: "20px", padding: "10px", background: "#111827", borderRadius: "8px" }}>
  <h3 style={{ marginBottom: "10px" }}>{t("demo.trends.recentSignalsTrend")}</h3>

  <ResponsiveContainer width="100%" height={200}>
    <LineChart data={fentanylTrend.map((v, i) => ({
  timestamp: i,
  fentanyl: v,
  voc: voc,
  pm25: pm25
}))}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="timestamp" hide />
      <YAxis />
      <Tooltip />
      <Line type="monotone" dataKey="fentanyl" stroke="#ef4444" name="Signal" />
      <Line type="monotone" dataKey="voc" stroke="#3b82f6" name="VOC" />
      <Line type="monotone" dataKey="pm25" stroke="#10b981" name="PM2.5" />
    </LineChart>
  </ResponsiveContainer>
</div>


{/* OPERATOR ACTION POPUP */}
{showActionPopup && (
  <div style={styles.popupBg}>
    <div style={{ ...styles.popup, width: 420 }}>
      <h2>{t("demo.popups.operatorActionRequired")}</h2>

      <p style={{ fontSize: "0.9rem", opacity: 0.8 }}>
        {t("demo.popups.alertTypeLabel")} <strong>{t(`demo.alertTypeValue.${pendingAlertType}`, pendingAlertType)}</strong>
      </p>

      <textarea
        placeholder={t("demo.popups.actionPlaceholder")}
        value={actionText}
        onChange={(e) => setActionText(e.target.value)}
        style={{
          width: "100%",
          minHeight: 100,
          marginTop: 12,
          padding: 10,
          borderRadius: 6,
          border: "1px solid #ccc",
        }}
      />

      <button
        disabled={!actionText.trim()}
        onClick={() => {
          const time = new Date().toLocaleTimeString();

// Save operator action
setOperatorActions(prev => [
  {
    time,
    type: pendingAlertType,
    action: actionText,
    operator: role,
  },
  ...prev,
]);
setLastActionTime(Date.now());

// ⭐ Save feedback for Explainable AI
setFeedbackLog(prev => [
  {
    time,
    risk: risk.level,
    type: pendingAlertType,
    action: actionText,
    zone: "Campus Zone A",
  },
  ...prev,
]);



          // Log event
addLog("demo.eventLog.actionRecordedBy", {
  type: pendingAlertType,
  role,
  action: actionText,
});

// Reset
setActionText("");
setPendingAlertType(null);
setShowActionPopup(false);
        }}
        style={{
          ...styles.ackBtn,
          marginTop: 16,
          opacity: actionText.trim() ? 1 : 0.5,
        }}
      >
        {t("demo.popups.submitAction")}
      </button>
    </div>
  </div>
)}

</div>
);
}

const getRiskStyle = (level) => {
  if (level === "CRITICAL") {
    return {
      border: "2px solid #ef4444",
      boxShadow: "0 0 14px rgba(239,68,68,0.7)",
    };
  }

  if (level === "WARNING") {
    return {
      border: "2px solid #facc15",
    };
  }

  return {};
};


/* ---------- STYLES ---------- */

const styles = {
  page: {
  minHeight: "100vh",
  background: "linear-gradient(180deg, #020617 0%, #020617 60%, #030712 100%)",
  color: "#e5e7eb",
  padding: "36px",
  fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont",
},

  header: {
  textAlign: "center",
  marginBottom: 18,
  paddingBottom: 16,
},
title: {
  fontSize: "2.4rem",
  fontWeight: 800,
  letterSpacing: "0.08em",
},
  subtitleWrap: {
    marginTop: 6,
    textAlign: "center",
  },
   demoNotice: {
  margin: "10px 0 18px",
  padding: "10px 14px",
  borderRadius: 10,
  background: "#020617",
  border: "1px solid #1e293b",
  fontSize: "0.95rem",
  lineHeight: 1.5,
  opacity: 0.9,
},

subtitleMain: {
  fontSize: "1.25rem",
  fontWeight: 500,
  opacity: 0.9,
},

  subtitleDemo: {
    marginTop: 4,
    fontSize: "1.2rem",
    fontWeight: 800,
    letterSpacing: "0.14em",
    color: "#fbbf24",
  },

  controlBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 18,
  },
    
  grid: {
  display: "grid",
  gridTemplateColumns: "1.2fr 1.6fr 1.2fr",
  gap: 20,
  alignItems: "start",   // ?? THIS FIXES THE MISALIGNMENT
},
  card: {
  background: "#0f172a",
  padding: 16,
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
},
statusCard: {
  minHeight: 140,   // ?? key alignment fix
},

  logBox: {
    marginTop: 10,
    maxHeight: 150,
    overflowY: "auto",
    fontSize: "0.85rem",
    opacity: 0.85,
  },
  popupBg: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,            // ?? FORCE ABOVE LEAFLET
  },
  popup: {
    background: "white",
    color: "black",
    padding: 30,
    borderRadius: 12,
    width: 320,
    textAlign: "center",
    zIndex: 10000,           // ?? EXTRA SAFETY
  },

  ackBtn: {
    marginTop: 15,
    padding: "10px 20px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  },
  audioBtn: {
    marginBottom: 20,
    padding: "8px 14px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  },
  trendRow: {
  display: "flex",
  alignItems: "flex-end",
  gap: 6,
  marginTop: 8,
  height: 140,               // ?? more vertical room
  background: "#020617",    // contrast
  padding: "6px",
  borderRadius: 6,
  },

trendBar: {
  width: 12,
  minHeight: 8,             // ?? ensures visibility
  borderRadius: 4,
  transition: "height 0.3s",
 },

riskBanner: (level) => ({
  margin: "8px 0 16px",
  padding: "12px 20px",
  borderRadius: 14,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background:
    level === "CRITICAL"
      ? "linear-gradient(90deg,#7f1d1d,#450a0a)"
      : level === "WARNING"
      ? "linear-gradient(90deg,#78350f,#451a03)"
      : "linear-gradient(90deg,#064e3b,#022c22)",
  color: "#e5e7eb",
  letterSpacing: "0.04em",
  boxShadow: "0 0 12px rgba(0,0,0,0.35)",
}),

healthPanel: {
  display: "flex",
  justifyContent: "space-between",
  gap: 20,
  padding: "12px 18px",
  marginBottom: 24,
  borderRadius: 10,
  background: "#020617",
  border: "1px solid #1e293b",
  fontSize: "0.9rem",
  opacity: 0.95,
  },
  kpiStrip: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
  gap: 20,
  marginBottom: 18,
  padding: "10px 18px",
  borderRadius: 14,
  background: "#020617",
  border: "1px solid #1e293b",   // ✅ static only
},


kpiValue: {
  fontSize: "1.6rem",
  fontWeight: 700,
},

kpiLabel: {
  fontSize: "0.8rem",
  opacity: 0.7,
  marginTop: 4,
},
bannerAlert: {
  background: "#7f1d1d",
  color: "white",
  padding: "12px 18px",
  borderRadius: 10,
  margin: "12px 0 18px",

  fontWeight: 600,
  textAlign: "center",
  boxShadow: "0 0 12px rgba(0,0,0,0.4)",
},
kpiGrid: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: 12,
  marginTop: 10,
},

kpiBox: {
  background: "#020617",
  border: "1px solid #1e293b",
  borderRadius: 8,
  padding: "10px 12px",
  textAlign: "center",
},

kpiTitle: {
  fontSize: "0.75rem",
  opacity: 0.7,
  letterSpacing: "0.05em",
},

kpiNumber: {
  fontSize: "1.3rem",
  fontWeight: 700,
  marginTop: 4,
},
bottomRow: {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 16,
  marginTop: 24,
},

trendRowCompact: {
  display: "flex",
  alignItems: "flex-end",
  gap: 6,
  height: 90,
  background: "#020617",
  padding: 6,
  borderRadius: 6,
},

logBoxTall: {
  marginTop: 10,
  maxHeight: 120,
  overflowY: "auto",
  fontSize: "0.85rem",
},
explainBox: {
  marginTop: 8,
  padding: "10px 14px",
  borderRadius: 10,
  background: "#020617",
  border: "1px solid #1e293b",
  fontSize: "0.85rem",
  opacity: 0.85,
},
aiGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 16,
  marginBottom: 8,
},
memoryGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: 10,
  marginTop: 10,
},

memoryItem: {
  background: "#020617",
  border: "1px solid #1e293b",
  borderRadius: 8,
  padding: "8px 10px",
},
explainPanel: {
  background: "#020617",
  border: "1px solid #1e293b",
  borderRadius: 10,
  padding: "12px 16px",
  marginTop: 10,
  marginBottom: 16,
  fontSize: "0.9rem",
  opacity: 0.9,
},
riskMeterContainer: {
  width: "100%",
  height: 14,
  background: "#020617",
  borderRadius: 10,
  marginTop: 10,
  marginBottom: 18,
  border: "1px solid #1e293b",
  overflow: "hidden",
  boxShadow: "inset 0 0 6px rgba(0,0,0,0.6)",
},
riskMeter: {
  height: "100%",
  borderRadius: 10,
  transition: "width 0.6s ease",
  boxShadow: "0 0 8px rgba(0,0,0,0.4)",
},
};
